import React,{useState,useEffect,useRef} from "react";
import './ReleaseMusic.css'
import { Trans, useTranslation} from 'react-i18next'
import Disclaimericon from './../../../../images/disclaimericon.png'
import RequestSubmittedIcon from './../../../../images/requestsubmittedicon.png'
import {useLocation,useNavigate} from "react-router-dom";
import { useJwt, decodeToken } from "react-jwt";
import Cookies from "universal-cookie";


function ReleaseDate({pagePath,setPagePath,getMonthNo,getDateNo,getMonthTxt,releaseDate,setReleaseDate,releaseDateError,setReleaseDateError}) {
    const ref = useRef(null)
    const dateInputRef = useRef(null);
    const {t, i18n } = useTranslation();
    const [releaseDateUpload,setReleaseDateUpload] = useState("")
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const [dragActive , setDragActive] = useState(false)
    const navigate = useNavigate();
    const cookies = new Cookies(null ,{ path: '/' });

    const location = useLocation();


    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }

    {/** Album Release Date error check */}
    const submitReleaseDate = (value) =>{
        
        const date = new Date(value.concat("T00:00"))
    
        console.log(date)
    
        const today = new Date()
    
        setReleaseDateUpload("".concat(date.getFullYear()).concat("-").concat(getMonthNo(date.getMonth()).concat("-").concat(getDateNo(date.getDate()))))
        console.log("".concat(date.getFullYear()).concat("-").concat(getMonthNo(date.getMonth()).concat("-").concat(getDateNo(date.getDate()))))
        console.log(date)
        console.log(today)
        let Difference_In_Time = date.getTime() - today.getTime();
        let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
        console.log(Difference_In_Days)
        if(Difference_In_Days>30){
        setReleaseDateError(3)
        }else{
        setReleaseDateError(2)
        }
        setReleaseDate(getMonthTxt(date.getMonth()).concat(" ").concat(date.getDate()).concat(", ").concat(date.getFullYear()))
    }

    useEffect(()=>{
        if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
            setPagePath("/Dashboard/releasemusic/releasedate")
         }
      
         if(decodeToken(cookies.get('token')).info.role==="label"){
            setPagePath("/dashboard/label/releasemusic/releasedate")
         }
    },[])

    return (
        <div style={{display:'flex',flexDirection:'column',alignItems:"center"}} ref={ref}>
        <div className="AddMusicHeader">{t('Releasedate')}</div>
  
        <div className="AddMusicDesc">{t('Whatdaydoyouwant')}</div>

        <div className="ReleaseDateContainer">
                <div style={{display:'flex',flexDirection:'column',width:'34.82%',alignSelf:'center',cursor:'pointer'}}
                onClick={() => dateInputRef.current && dateInputRef.current.showPicker()}>
                    <div className="ReleaseDateTxt">
                    {t('Selectareleasedate')}
                    </div>

                    <div className='ReleaseDateBox'>
                    {
                        releaseDate.length===0 && 
                        <div>
                        {t('Selectadate')}
                        </div>
                    }
                        {
                        releaseDate.length!==0 && 
                        <div>
                        {releaseDate}
                        </div>
                    }
                    <input
                                 ref={dateInputRef}
                                value={releaseDate}
                                onChange={e =>submitReleaseDate(e.target.value)} 
                                onSubmit={e =>submitReleaseDate(e.target.value)}
                                className='ReleaseDateInputBox'
                                type='date'
                                
                                />
                    </div>
                    
                </div>

                    {
                    releaseDateError===2 &&
                    <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',width:'58.18%',marginTop:'2.5em',alignSelf:'center'}}>
                                        <img src={Disclaimericon} style={{width:'1.5em',height:'1.5em',marginTop:'0.1em'}}/>
                                        <div className="ReleaseDateDisclaimer"> 
                                        {t('Yourreleasedatreistosoon')}
                                        </div>
                                    </div>
                    }

                    {
                    releaseDateError===3 &&
                    <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'center',width:'58.18%',marginTop:'2.5em',alignSelf:'center'}}>
                    <img src={RequestSubmittedIcon} style={{width:'1.5em',height:'1.5em',marginTop:'0.1em'}}/>
                    <div className="ReleaseDateDisclaimer"> 
                    {t('Yourreleasedatreisgood')}
                        </div>
                    </div>
                    }
            
            </div>

            <div style={{display:'flex',flexDirection:'row',marginTop:'3.5em',paddingBottom:'4em'}}>
                <div className="BackBtn2" onClick={()=>{
                    {/** PENDING */}
                    // setPageNo(5);
                    if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                        navigate("/Dashboard/releasemusic/royaltysplit");
                      }
            
                      if(decodeToken(cookies.get('token')).info.role==="label"){
                        navigate("/dashboard/label/releasemusic/royaltysplit")
                      }
                    
                                                        topFunction()}}>
                {t('Back')}
                </div>
                
                {
                releaseDate.length===0 &&
                <div className="NextBtn2" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                {t('Continuedate')}
                </div>
                }

                {
                releaseDate.length!==0 &&
                <div className="NextBtn2" onClick={()=>{
                    // setAlbumReleaseDate();
                    {/** PENDING */}
                    // setPageNo(7)
                    if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                        navigate("/Dashboard/releasemusic/albumsummary");
                      }
            
                      if(decodeToken(cookies.get('token')).info.role==="label"){
                        navigate("/dashboard/label/releasemusic/albumsummary")
                      }
                    
                    topFunction()}}>
                    {t('Continuedate')}
                    <div className="PostLoginBtnOverlay"/>
                </div>
                }
                
            </div>
        </div> 
    );
}

export default ReleaseDate;